import { Link } from "react-router-dom";


export default function NotFound() {
  return (
    <div>
        <h2>The page you requested was not found.</h2>
        <p>Go to <Link to='/'>Home Page</Link></p>
    </div>
  )
}
